enum UnsubscribeResponseType {
    Fail,
    Success
}
export default UnsubscribeResponseType;
